import { render, staticRenderFns } from "./TagsSection.vue?vue&type=template&id=50621729&scoped=true"
import script from "./TagsSection.vue?vue&type=script&lang=js"
export * from "./TagsSection.vue?vue&type=script&lang=js"
import style0 from "./TagsSection.vue?vue&type=style&index=0&id=50621729&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50621729",
  null
  
)

export default component.exports